import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const PRICING_RETURN_PATH_KEY = "pricing-return-path";

const PRICING_RETURN_PATH_TTL_MS = 60 * 60 * 1000;

interface PricingReturnPathEntry {
  path: string;
  storedAt: number;
}

const pricingReturnPathStorageAtom = atomWithStorage<PricingReturnPathEntry | null>(
  PRICING_RETURN_PATH_KEY,
  null,
  createJSONStorage(() => sessionStorage),
  { getOnInit: true }
);

export const pricingReturnPathAtom = atom(
  function readUnexpiredPath(get) {
    const entry = get(pricingReturnPathStorageAtom);
    if (!entry) {
      return null;
    }

    const isExpired = Date.now() - entry.storedAt > PRICING_RETURN_PATH_TTL_MS;
    return isExpired ? null : entry.path;
  },
  function writePath(_get, set, path: string | null) {
    set(pricingReturnPathStorageAtom, path ? { path, storedAt: Date.now() } : null);
  }
);
